import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";

@Injectable()
export class BuildsService {

  constructor(private  http:HttpClient) { }
  getBuilds() {
    return this.http.get('http://www.api.playit.mobi/api/v2/Android/builds').map(result => result);
  }
  getpkgBuilds(pkgName) {
    return this.http.get('http://www.api.playit.mobi/api/v2/Android/builds/package?packageName=${pkgName}').map(result => result);

  }
  addBuild(data) {
    return this.http.post(`http://www.api.playit.mobi/api/v2/Android/builds`, data).map(result => result);
  }
  editBuild(id,data) {
    return this.http.post(`http://www.api.playit.mobi/api/v2/Android/builds/${id}`, data).map(result => result);

  }
  deleteBuild(id) {
    return this.http.delete(`http://www.api.playit.mobi/api/v2/Android/builds/${id}`).map(result => result);
  }


}



// WEBPACK FOOTER //
// D:/xampp/htdocs/playitadmin_frontend/src/app/Services/builds/builds.service.ts